import { render } from "./WidgetBestSellersByQuantity.vue?vue&type=template&id=910d3c42&scoped=true&ts=true"
import script from "./WidgetBestSellersByQuantity.vue?vue&type=script&lang=ts"
export * from "./WidgetBestSellersByQuantity.vue?vue&type=script&lang=ts"

import "./WidgetBestSellersByQuantity.vue?vue&type=style&index=0&id=910d3c42&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-910d3c42"]])

export default __exports__